import { printLog } from "../../tools/log";
import { message } from 'ant-design-vue';
import { collectionService } from "../../services/collectionService";
import { getCollectionCtor } from "../templates";
import { RelationalCollection } from "./RelationalCollection";
// 应该没有内存膨胀的危险，collection的数目有限的，使用Promise是为了聚合同一时间的并发请求
const cacheMap = new Map();
// @ts-ignore
if (!window.__xy_source_cacheMap__) {
  Object.defineProperty(window, '__xy_source_cacheMap__', {
    value: cacheMap,
    enumerable: false
  });
}
function getCacheKey(collectionId, projectId, envId, simplifyCgiSchema) {
  const simplifyString = simplifyCgiSchema ? 'simplify' : 'notSimplify';
  return [collectionId, projectId, envId, simplifyString].join('/');
}
export function clearCollectionCache() {
  cacheMap.clear();
}
export async function getCollectionData(options) {
  const {
    collectionId,
    projectId,
    pageId,
    envId,
    useCache,
    simplifyCgiSchema
  } = options;
  const cacheKey = getCacheKey(collectionId, projectId, envId, simplifyCgiSchema);
  const fetchOptions = {
    collectionId,
    projectId,
    pageId,
    envId
  };
  let data;
  if (useCache) {
    if (!cacheMap.has(cacheKey)) {
      const res = retryFetchCollection(fetchOptions);
      cacheMap.set(cacheKey, res);
    }
    data = await cacheMap.get(cacheKey);
  } else {
    data = await retryFetchCollection(fetchOptions);
  }
  return data;
}
async function retryFetchCollection(params) {
  const fetchData = async () => {
    const data = await collectionService.findRuntimeConfig(params);
    return data;
  };
  // 容错重试
  try {
    return await fetchData();
  } catch (error) {
    console.error('数据源配置获取重试', error);
    await new Promise(r => setTimeout(r, 500));
    return await fetchData();
  }
}
/**
 * 数据源预加载
 * @param collectionIds
 * @param config
 * @returns
 */
export async function preloadCollections(collectionIds, config) {
  const ids = collectionIds.filter(id => {
    const key = getCacheKey(id, config.projectId, config.envId, true);
    return !cacheMap.has(key);
  });
  const fetchOptions = {
    collectionIds: ids,
    simplifyCgiSchema: true,
    ...config
  };
  const listPromise = collectionService.findRuntimeConfigList(fetchOptions);
  ids.forEach(id => {
    const key = getCacheKey(id, config.projectId, config.envId, true);
    const promise = (async () => {
      const list = await listPromise;
      const target = list.find(item => item.collectionId === id);
      if (target) {
        return target;
      }
      cacheMap.delete(key);
      return;
    })();
    cacheMap.set(key, promise);
  });
  listPromise.then(res => printLog('[preload source] list', res));
  return listPromise;
}
export async function getCollection(options) {
  const data = await getCollectionData(options);
  if (!data) {
    const msg = [`获取数据源[${options.collectionId}]失败，该数据源可能已经被删除`, options.envId !== 'dev' ? `，或者该数据源未同步到[${options.envId}]环境!` : ''].join('\n');
    message.error(msg);
    throw new Error(msg);
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const Collection = data.type === 'combineData' ? RelationalCollection : getCollectionCtor(data.tplType);
  if (!Collection) {
    throw new Error(`找不到 ${data.tplType} 模板类型`);
  }
  const collectionOption = {
    envId: options.envId,
    projectId: options.projectId,
    pageId: options.pageId,
    getDynamicParamValues: options.getDynamicParamValues,
    internal: options.internal,
    useOrInsteadOfIn: options.useOrInsteadOfIn
  };
  const collection = new Collection(data, collectionOption);
  if (Collection === RelationalCollection) {
    await collection.readyTask;
  }
  return collection;
}
//# sourceMappingURL=getCollection.js.map
